module.exports = __webpack_public_path__ + "static/img/bg-partnership.d148da75.jpg";